import React from "react";
import { styled } from "@mui/system";
import MUIListItemIcon, { ListItemIconProps } from "@mui/material/ListItemIcon";

interface ListItemIconPropsExtended extends ListItemIconProps {
  variant?: String;
}

export const ListItemIcon = styled(
  (props: ListItemIconPropsExtended) => <MUIListItemIcon {...props} />,
  {
    name: "ListItemIcon",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "variant" && prop !== "myProp",
    overridesResolver: (props, styles) => [],
  }
)(({ theme, variant }) => ({
  "&.MuiListItemIcon-root": {
    minWidth: 32,
    color: theme.palette.primary.iconDefault,
    "& .MuiFormControlLabel-root": {
      marginRight: 0,
    },
  },
  "&.MuiListItemIcon-root .MuiSvgIcon-root": {
    fontSize: 20,
    color: variant === "menuIcon" && theme.palette.primary.white,
    // color: theme.palette.primary.white,
  },
  "&.MuiListItemIcon-root svg": {
    fontSize: 20,
    color: variant === "menuIcon" && theme.palette.primary.white,
  },
  "&.MuiListItemIcon-root .MuiCheckbox-root": {
    padding: 0,
  },
}));
